<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import { useStore } from 'dashboard/composables/store';
const store = useStore();
</script>

<template>
  <div
    role="alert"
    class="flex flex-col items-start gap-3 rounded-xl border border-n-weak p-3 text-n-slate-12"
  >
    <p class="m-0 text-body-main">{{ $t('MACROS.LIST.LOAD_ERROR') }}</p>
    <Button
      slate
      ghost
      icon="i-ph-arrow-clockwise"
      class="!min-h-11"
      :label="$t('MACROS.EDITOR.RETRY')"
      @click="store.dispatch('macros/get')"
    />
  </div>
</template>
